module.exports = __webpack_public_path__ + "static/media/spinner.31d7c9b7.gif";